import * as Sentry from '@sentry/react';
import toast from 'react-hot-toast';
import appString from '../../../../common/app_strings';

const { wholeMeProfileStory: { errors } } = appString;

export const handleError = (e) => {
  const errorMessage = e.message || e.toString();
  console.error('Error with story request: ', e);
  Sentry.captureException(e);
  if (errorMessage === errors.characterLimit) {
    toast.error(errors.characterLimit, { duration: 4000 });
  } else {
    toast.error(errors.requestError, { duration: 4000 });
  }
};

export const handleMediaError = (e, mediaType) => {
  console.error('Error uploading story media: ', e);
  Sentry.captureException(e);
  toast.error(errors.mediaError(mediaType), { duration: 4000 });
};
